import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoAgahShadow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={52} height={52} fill='none' {...props}>
    <g
      fillRule='evenodd'
      clipPath='url(#logo-agah-shadow_svg__a)'
      clipRule='evenodd'
      filter='url(#logo-agah-shadow_svg__b)'
    >
      <path
        fill='currentColor'
        d='M25.703 5a20.7 20.7 0 0 0-8.838 1.998 20.7 20.7 0 0 0-7.145 5.588A20.8 20.8 0 0 0 5.633 20.7 20.87 20.87 0 0 0 9.02 38.11a20.75 20.75 0 0 0 6.828 5.975 20.68 20.68 0 0 0 17.652.998 271 271 0 0 1-3.25-7.68 12.36 12.36 0 0 1-7.737.385 12.4 12.4 0 0 1-6.455-4.296 12.477 12.477 0 0 1-.48-14.759c1.5-2.189 3.66-3.839 6.163-4.708a12.36 12.36 0 0 1 7.744-.123c2.529.79 4.739 2.371 6.307 4.512a12.47 12.47 0 0 1 2.41 7.386H46.6a20.9 20.9 0 0 0-1.613-7.987 20.9 20.9 0 0 0-4.539-6.76 20.8 20.8 0 0 0-6.772-4.499A20.7 20.7 0 0 0 25.702 5'
      />
      <path
        fill='currentColor'
        d='m25.692 25.812 4.558 11.58a12.13 12.13 0 0 0 5.806-4.524 12.2 12.2 0 0 0 2.136-7.057z'
      />
    </g>
    <defs>
      <clipPath id='logo-agah-shadow_svg__a'>
        <path fill='#fff' d='M0 0h52v52H0z' />
      </clipPath>
      <filter
        id='logo-agah-shadow_svg__b'
        width={51.6}
        height={51.6}
        x={0}
        y={0}
        colorInterpolationFilters='sRGB'
        filterUnits='userSpaceOnUse'
      >
        <feFlood floodOpacity={0} result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          result='hardAlpha'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
        />
        <feOffset />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values='0 0 0 0 0.266667 0 0 0 0 0.541176 0 0 0 0 1 0 0 0 1 0' />
        <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_2877_9384' />
        <feBlend in='SourceGraphic' in2='effect1_dropShadow_2877_9384' result='shape' />
      </filter>
    </defs>
  </svg>
);
export default SvgLogoAgahShadow;
